
import clamp from '../../../vendor/scripts/fabrique/modules/number-clamp';
import Component from '../../../assets/scripts/modules/component';
import offset from '../../../vendor/scripts/fabrique/modules/number-offset';
import onValuesChange from '../../../vendor/scripts/fabrique/modules/on-values-change';
import percentage from '../../../vendor/scripts/fabrique/modules/percentage';
import required from '../../../vendor/scripts/fabrique/modules/required';
import round from '../../../vendor/scripts/fabrique/modules/number-round';
import visibleRect from '../../../vendor/scripts/fabrique/modules/visible-rect';

class Quetzalcoatl extends Component {

  constructor() {
    super(...arguments);
  }

  init() {

    this.imageWrappers = this.element.querySelectorAll('.quetzalcoatl-row__image-wrapper');
    this.contentWrappers = this.element.querySelectorAll('.quetzalcoatl-row__content-wrapper');

    this.timingResolution = 10; // 10x

    window.requestAnimationFrame(() => this.initTweens());

    this.interval = onValuesChange(values => this.doTweens(values), 16.6667,
      { name: 'y', cb: () => window.scrollY || document.body.scrollTop || document.querySelector('.main').scrollTop },
      { name: 'width', element: window, property: 'innerWidth' },
      { name: 'height', element: window, property: 'innerHeight' }
    );

    window.requestAnimationFrame(() => this.doTweens());
  }

  initTweens() {

    for (const imageWrapper of this.imageWrappers) {
      this.initImageTween(imageWrapper);
    }

    for (const contentWrapper of this.contentWrappers) {
      this.initTextTween(contentWrapper);
    }

  }

  initImageTween(element = required()) {
    const picture = element.querySelector('.picture__picture');

    if (!picture) {
      return;
    }

    const tween = {
      lastPosition: 0,
      start: () => 0,
      distance: (rect = required()) => rect.width / 2,
      position: (rect = required()) => Math.min(-(rect.top - window.innerHeight), rect.top + rect.height),
      animation: picture.animate([
        { transform: 'scale(.75)', offset: 0 },
        { transform: 'scale(1)', offset: 1 },
      ], { fill: 'forwards', duration: this.timingResolution * 100, easing: 'ease-out' }),
    };

    tween.animation.currentTime = 0;
    tween.animation.pause();

    element.tween = tween;

  }

  initTextTween(element = required()) {
    const richtext = element.querySelector('.richtext');

    const tween = {
      lastPosition: 0,
      start: (rect = required()) => rect.width / 4,
      distance: (rect = required()) => rect.width / 2,
      position: (rect = required()) => Math.min(-(rect.top - window.innerHeight), rect.top + rect.height),
      animation: richtext.animate([
        { opacity: 0, easing: 'ease-out', offset: 0 },
        { transform: 'translate3d(0, 20px, 0)', easing: 'ease-out', offset: 0},
        { opacity: 1, easing: 'ease-in', offset: 1 },
        { transform: 'translate3d(0, 0, 0)', easing: 'ease-in', offset: 1 },
      ], { fill: 'forwards', duration: this.timingResolution * 100 }),
    };

    tween.animation.currentTime = 0;
    tween.animation.pause();

    element.tween = tween;

  }

  doTweens(values = { 'y': window.scrollY, 'width': window.innerWidth, 'height': window.innerHeight }) {

    for (const imageWrapper of this.imageWrappers) {
      this.doImageTween(imageWrapper, values);
    }

    for (const contentWrapper of this.contentWrappers) {
      this.doTextTween(contentWrapper, values);
    }

  }

  doImageTween(element = required(), values = required()) {
    let rect = visibleRect(element, values['height'] * 4);

    if (!rect) {
      return;
    }

    const tween = element.tween;

    if (!tween) {
      return;
    }

    // Don't tween out of view, only into view
    if (rect.top <= 0) {
      tween.animation.currentTime = this.timingResolution * 100;
      tween.lastPosition = 100;

      // Don't tween in the future
      tween.animation.cancel();
      element.tween = null;

      return;
    }

    const [ start, distance, position] = offset(tween.start(rect), tween.start(rect) + tween.distance(rect), tween.position(rect));
    const value = round(clamp(percentage(start, distance, position)));

    if (tween.lastPosition !== value) {
      tween.animation.currentTime = this.timingResolution * value;
      tween.lastPosition = value;

      // Don't tween in the future
      if (value === 100) {
        tween.animation.cancel();
        element.tween = null;
      }
    }

  }

  doTextTween(element = required(), values = required()) {
    let rect = visibleRect(element, values['height'] * 4);

    if (!rect) {
      return;
    }

    const tween = element.tween;

    if (!tween) {
      return;
    }

    // Don't tween out of view, only into view
    if (rect.top < values['height'] / 2) {
      tween.animation.currentTime = this.timingResolution * 100;
      tween.lastPosition = 100;

      // Don't tween in the future
      tween.animation.cancel();
      element.tween = null;

      return;
    }

    const [ start, distance, position] = offset(tween.start(rect), tween.start(rect) + tween.distance(rect), tween.position(rect));
    const value = round(clamp(percentage(start, distance, position)));

    if (tween.lastPosition !== value) {
      tween.animation.currentTime = this.timingResolution * value;
      tween.lastPosition = value;

      // Don't tween in the future
      if (value === 100) {
        tween.animation.cancel();
        element.tween = null;
      }
    }
  }
}

for (const element of document.querySelectorAll('.quetzalcoatl')) {
  element.instance = new Quetzalcoatl('quetzalcoatl', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/organisms/quetzalcoatl/quetzalcoatl.js